export default {
    pt: "Português"
}